import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://gnxjvarcpwdoaiextmos.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImdueGp2YXJjcHdkb2FpZXh0bW9zIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjIxNjk4OTIsImV4cCI6MjA3Nzc0NTg5Mn0.8D01hN-R2my3R5c5T9yO-GUsS42hp23xHieLkNOTFhk'

if(!SUPABASE_URL || !SUPABASE_ANON_KEY ){
  throw new Error('Missing Supabase variables');
}

export default createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
})